import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subject, take, delay } from 'rxjs';

@Component({
    selector: 'app-drop-down-list-input',
    templateUrl: './drop-down-list-input.component.html',
    styleUrls: ['./drop-down-list-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DropDownListInputComponent implements OnInit {

  @Input() value: string;
  @Input() displayOptions: { label:string, value: string }[];
  @Input() width: number;

  @Output() inputValue: EventEmitter<string> = new EventEmitter();

  public formCtrl: UntypedFormControl = new UntypedFormControl();
  public isShowOverlay = false;
  private subject = new Subject();

  constructor() {}

  ngOnInit() {}

  ngOnDestroy() {
    if (this.subject) {
      this.subject.unsubscribe();
      this.subject = null;
    }
  }

  showOverlay() {
    this.isShowOverlay = true;
  }

  hideOverlay() {
    this.subject.pipe(take(1), delay(300)).subscribe((_) => {
      this.isShowOverlay = false;
    });

    this.subject.next(null);
  }

  selectValue(value: string) {
    this.formCtrl.setValue(value);
  }

  inputEmit() {
    this.inputValue.emit(this.value);
  }

  replaceLabel(value: string): string {
    return value.replace('objects.', '');
  }
}
